export default {
      id: "alert-usage",
      viewBox: "0 0 37 34",
      url: __webpack_public_path__ + "sprite.svg#alert",
      toString: function () {
        return this.url;
      }
    }